module.exports = __webpack_public_path__ + "media/images/post/icon_translator-e0336a81587c498f5c78dd55abe93596.png";